module.exports = __webpack_public_path__ + "img/4-low.af058c01.jpg";